import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { APPLICATION_ACTIONS } from '../actions/application.actions';
import { catchError, map, pluck, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { EStorageMessages } from '../../configurations/application.config';
import { AUTH_ACTIONS } from '../actions/auth.actions';
import { Store } from '@ngrx/store';
import { ApplicationService } from '../../services/application.service';
import { AUTH_SELECTORS } from '../selectors/auth.selectors';
import { ExagoService } from '../../services/exago.service';
import { IExagoFolderNode } from '../../../feature-modules/exago/models/exago.models';
import { NavigationService } from '../../services/navigation.service';
import { from, of } from 'rxjs';
import { CLAIMS_ACTIONS } from '../actions/claims.actions';

@Injectable()
export class ApplicationEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly applicationService: ApplicationService,
    private readonly navigationService: NavigationService,
    private readonly exagoService: ExagoService,
  ) {}

  messageReceived$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(APPLICATION_ACTIONS.messageReceived),
        tap(({ message }) => {
          switch (message) {
            case String(EStorageMessages.logout):
              this.store.dispatch(AUTH_ACTIONS.logoutNotification());
              break;
            case String(EStorageMessages.login):
              this.store.dispatch(AUTH_ACTIONS.loginNotification());
              break;
          }
        }),
      ),
    { dispatch: false },
  );

  buildNavigation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CLAIMS_ACTIONS.getClaimsSuccess),
      withLatestFrom(this.store.select(AUTH_SELECTORS.userId), this.store.select(AUTH_SELECTORS.exagoRole)),
      switchMap(([, userId, role]) =>
        this.exagoService.getFolders(userId, role).pipe(
          pluck('entity'),
          //TODO: process the error properly and show to user some meaningful page
          catchError(() => of([])),
          switchMap((folders: IExagoFolderNode[]) => from(this.navigationService.getNavigation(folders))),
          map((navigation) => APPLICATION_ACTIONS.configureNavigationComplete({ navigation })),
        ),
      ),
      switchMap((action) => [action, APPLICATION_ACTIONS.hideLoader()]),
    ),
  );

  sendMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(APPLICATION_ACTIONS.sendMessage),
        tap(({ message }) => this.applicationService.sendAppMessage(message)),
      ),
    { dispatch: false },
  );
}
